import { useState } from "react";
import { HelpTextSaveModel, HelpTextViewModel } from "./HelpTexts.types";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useHelpTextDataMapping() {
    const url = "/helptexts";
    const { isLoading, data, refetch } = useDotLegalQuery<Array<HelpTextViewModel>>(url);
    const [showDialog, setShowDialog] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [selectedHelpText, setSelectedHelpText] = useState<HelpTextSaveModel>(getEmptyHelpText());

    function getEmptyHelpText() {
        return { id: "", header: "", content: "", type: undefined };
    }

    const hasHelpTexts = isLoading || data!.length > 0;

    return {
        isLoading,
        data,
        refetch,
        showDialog,
        setShowDialog,
        selectedHelpText,
        setSelectedHelpText,
        getEmptyHelpText,
        showDeleteDialog,
        setShowDeleteDialog,
        hasHelpTexts,
    };
}
